import * as React from 'react';
import { confirmAlert } from '../mini/alanConfirmAlert';
import NewScriptForm from '../../views/pages/project/NewScriptForm/NewScriptForm';
import store from '../../store';
import { IProject } from '../../models/IProject';

function createNewScriptHelper(project: IProject, createScript) {
    confirmAlert({
        customUI: ({ onClose }) => {
            return (
                <NewScriptForm
                    project={project}
                    createScript={createScript}
                    onClose={onClose}
                    store={store} />
            );
        }
    });
}

export default createNewScriptHelper;
